/**
 * Monaco Editor 本地加载配置
 *
 * @monaco-editor/react 默认从 jsDelivr CDN 加载 Monaco 核心库，
 * 在网络不稳定的环境中容易导致编辑器卡在 "Loading..." 状态。
 * 此文件通过以下方式解决：
 * 1. 使用 Vite 原生 Worker 机制加载 Web Worker（独立 chunk）
 * 2. 动态 import Monaco 核心模块（Vite 自动代码分割，避免主 bundle 过大导致构建 OOM）
 * 3. 覆写 loader.init 确保始终使用本地模块而非 CDN
 */
import { loader } from '@monaco-editor/react';

// 使用 Vite 的 ?worker 语法导入 Monaco Web Worker（生成独立 worker chunk）
import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import TsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';

// 配置 Monaco Web Worker，使用本地打包的 worker 替代 CDN
self.MonacoEnvironment = {
  getWorker(_: string, label: string) {
    if (label === 'typescript' || label === 'javascript') {
      return new TsWorker();
    }
    return new EditorWorker();
  },
};

// 动态导入 Monaco 核心模块：
// - 使用 import() 让 Vite 将 monaco-editor 拆分为独立 chunk 按需加载
// - 避免 import * as monaco 将 ~40MB 源码打入主 bundle 导致构建 OOM
// - 模块加载后立即缓存，后续 loader.init() 调用直接返回已加载实例
const monacoModule = import('monaco-editor');

// 覆写 @monaco-editor/react 的 loader.init，
// 确保始终使用本地动态导入的 Monaco 而非默认的 CDN 加载。
// 添加 cancel 空方法以兼容库内部清理逻辑（组件卸载时调用）
loader.init = () => Object.assign(monacoModule, { cancel: () => {} }) as any;
